module.exports = __webpack_public_path__ + "img/icon-apple.bc522089.svg";